import primary from "./primaryTheme/primaryTheme";

export let getTheme = () => {
  return { ...primary };
};

let selectedTheme = getTheme();

export default selectedTheme;
